<template>
  <el-dialog title="新建知识单" :visible.sync="visible" :append-to-body="true" width="500px" :before-close="handleClose"
             class="addKnowledgeDialog">
    <el-form ref="knowledgeFrom" :model="formData" label-width="100px">
      <el-form-item label="知识单名称：">
        <el-input v-model="formData.groupName" type="text" placeholder="请输入知识单名称" clearable/>
      </el-form-item>
      <el-form-item label="知识单封面：">
        <el-upload
          ref="uploadImage"
          :action="upload_url"
          list-type="picture-card"
          :http-request="UploadHttp"
          :before-upload="beforeAvatarUpload"
          :limit="1">
          <i class="el-icon-plus"></i>
        </el-upload>
        <p class="tips">目前我们支持的格式有jpg、gif、jpeg、bpm、png、svg</p>
        <p class="tips">大小限制10M</p>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submitUpload">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import { uploadImage } from '@/api/user';

  export default {
    name: 'UploadAvatar',
    props: {
      visible: { type: Boolean, default: false }
    },
    data () {
      return {
        formData: {
          groupName: '',
          groupImage: ''
        },
        upload_url: ''
      };
    },
    watch: {
      visible: function (newValue) {
        if (!newValue) {
          this.formData.groupImage = '';
          this.formData.groupName = '';
          this.$refs[ 'uploadImage' ].clearFiles();
        }
      }
    },
    methods: {
      handleClose () {
        this.$refs[ 'uploadImage' ].clearFiles();
        this.formData.groupImage = '';
        this.formData.groupName = '';
        this.$emit('close');
      },
      UploadHttp (files) {
        let file = files.file;
        const formData = new FormData();
        formData.append('origin', 'g12e');
        formData.append('wmType', '0');
        formData.append('files', file);
        uploadImage(formData).then(data => {
          if (data.success) {
            if (data.result.sArray.length <= 0) {
              this.$refs[ 'uploadImage' ].clearFiles();
              this.$message({
                type: 'error',
                message: '上传封面失败，请重试'
              });
            } else {
              let path = data.result.sArray[ 0 ].url;
              this.formData.groupImage = path;
            }

          } else {
            this.$refs[ 'uploadImage' ].clearFiles();
            this.$message({
              type: 'error',
              message: data.errorMsg || '上传封面失败，请重试'
            });
          }
        });
      },
      beforeAvatarUpload (file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        } else if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      submitUpload () {
        if (this.formData.groupName.trim() === '') {
          this.$message({
            type: 'error',
            message: '知识单名称不能为空'
          });
          return false;
        }

        if (!this.formData.groupImage) {
          this.$message({
            type: 'error',
            message: '知识单封面不能为空'
          });
          return false;
        }

        this.$emit('uploadSuccess', this.formData);
      }
    }
  };
</script>
<style lang="scss">
  .addKnowledgeDialog {
    .tips{
      line-height: 0;
      color: red;
      margin-top: 26px;
    }
    .el-form-item {
      .el-input {
        width: auto;
      }
    }
  }
</style>
